<template>
  <div class="topbar flex" style="z-index: 15;">
    <div class="fl">
      <a @click="returnPage">
        <i class="fa-angle-left"></i>
      </a>
    </div>
    <div class="span-title">
      <p class="f14">{{title}}</p>
      <p class="f12">{{title2}}</p>
    </div>
    <a class="lk-home" @click="toHome(detailType)">
      <i class="fa-home"></i>
    </a>
  </div>
</template>

<script>
  export default {
    name: "book-top",
    props: {
      title: String,
      title2: String,
      detailType: String,
    },
    methods: {
      returnPage() {
        this.$router.isBack = true;
        this.$router.go(-1)
      },
      toHome(t) {
        this.$router.isBack = false;
        console.log(t)
        if(t === 'vod'){
          this.$router.push('/vod');
        }else{
          this.$router.push('/home');
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layer2/book/book-top.vue